import Svg, { G, Path, Text, TSpan } from 'react-native-svg'

export const JioPay = () => {
  return (
    <Svg width="150" height="32" viewBox="0 0 150 32">
      <G id="Logo_on_light_bg" data-name="Logo on light bg" transform="translate(-16 -36)">
        <G id="logo_on_light_bg-2" data-name="logo on light bg" transform="translate(-331.357 0.08)">
          <Path
            id="Path_15"
            data-name="Path 15"
            d="M379.357,51.92a16,16,0,1,1-16-16,16,16,0,0,1,16,16"
            fill="#0070b6"
          />
          <Path
            id="Path_16"
            data-name="Path 16"
            d="M383.8,76.6a1.8,1.8,0,0,1-1.96-1.895,1.826,1.826,0,0,1,1.981-1.88h0A1.889,1.889,0,1,1,383.8,76.6m-3.023-4.109c-.465,0-.756-.254-.756-.66a.649.649,0,0,1,.733-.653c.465,0,.755.247.755.653a.65.65,0,0,1-.733.66m.681,3.368c0,.5-.254.675-.61.675H380.7c-.377,0-.639-.16-.639-.675V73.536c0-.509.269-.675.625-.675h.145c.377,0,.624.153.624.675Zm-1.893-1.227c0,1.35-.646,1.967-1.872,1.967-1.009,0-1.554-.356-1.554-.936a.727.727,0,0,1,.479-.726,1.069,1.069,0,0,0,.856.429c.443,0,.631-.2.631-.755V72.44c0-.45.218-.675.617-.675h.211c.414,0,.631.225.631.675Zm1.392-14.712a9.566,9.566,0,0,0-6.67,2.7h5.959a1.067,1.067,0,0,1,0,2.134h-7.621a9.533,9.533,0,0,0-.9,2.133h11.9a1.067,1.067,0,0,1,0,2.133H371.37q-.013.248-.013.5a9.664,9.664,0,0,0,.141,1.633h3.682a1.067,1.067,0,1,1,0,2.133h-3.055a9.6,9.6,0,1,0,8.833-13.366m2.85,13.965a.825.825,0,0,0,0,1.647.825.825,0,0,0,0-1.647"
            transform="translate(-17.6 -17.6)"
            fill="#fff"
          />
        </G>
        <Text
          id="JioPay_Business"
          data-name="JioPay Business"
          transform="translate(56 57)"
          fontSize="14"
          fontFamily="JioType-Bold, JioType"
          fontWeight="700">
          <TSpan x="0" y="0">
            JioPay Business
          </TSpan>
        </Text>
      </G>
    </Svg>
  )
}
